import { render, staticRenderFns } from "./CriticaItem.vue?vue&type=template&id=03aa78a8&scoped=true"
import script from "./CriticaItem.vue?vue&type=script&lang=js"
export * from "./CriticaItem.vue?vue&type=script&lang=js"
import style0 from "./CriticaItem.vue?vue&type=style&index=0&id=03aa78a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aa78a8",
  null
  
)

export default component.exports